import { render, staticRenderFns } from "./popup_nav.vue?vue&type=template&id=0b8a0273&scoped=true&"
import script from "./popup_nav.vue?vue&type=script&lang=js&"
export * from "./popup_nav.vue?vue&type=script&lang=js&"
import style0 from "./popup_nav.vue?vue&type=style&index=0&id=0b8a0273&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8a0273",
  null
  
)

export default component.exports